import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/interview/desktop-connect/DesktopConnectClient.tsx");
